import { Component, computed, ElementRef, linkedSignal, signal, viewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ICellEditorAngularComp } from "ag-grid-angular";
import { AgGridEditorOptions, AgGridEditorParams } from "./types";

@Component({
  selector: "ag-grid-multiline-editor",
  template: `
    <textarea
      #input
      class="bm-textarea min-w-xs min-h-80"
      [ngModel]="inputValue()"
      (ngModelChange)="outputValue.set($event)"
    ></textarea>
  `,

  imports: [FormsModule],
})
export class AgGridMultilineEditorComponent<TData> implements ICellEditorAngularComp {
  public static options<TData>(options: AgGridEditorOptions<TData, string>) {
    return options;
  }

  protected input = viewChild<ElementRef<HTMLTextAreaElement>>("input");
  protected params = signal<AgGridEditorParams<TData, string>>(null);
  protected inputValue = computed(() => {
    const params = this.params();
    let value = params.value;
    if (params.readValue) {
      value = params.readValue(params.data);
    }
    return value;
  });
  protected outputValue = linkedSignal<string>(() => this.inputValue());

  public agInit(params: AgGridEditorParams<TData, string>) {
    this.params.set(params);
  }

  public refresh(params: AgGridEditorParams<TData, string>) {
    this.params.set(params);
    return true;
  }

  public getValue() {
    const value = this.outputValue();
    if (this.inputValue() !== value && this.params().writeValue) {
      this.params().writeValue(this.params().data, value);
    }
    return value;
  }

  public isPopup(): boolean {
    return true;
  }

  public getPopupPosition() {
    return "under" as const;
  }

  public afterGuiAttached(): void {
    this.input()?.nativeElement.focus();
  }

  protected async handleCancelClicked() {
    this.params().stopEditing();
  }
}
